// src/components/ClientForms.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { fetchClientForms } from '../api';

const ClientForms: React.FC = () => {
  const [forms, setForms] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = async () => {
    setIsLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('clientToken');
      if (!token) throw new Error('No client authentication token found.');
      const response = await fetchClientForms(token);
      setForms(response);
    } catch (error: any) {
      console.error('Failed to fetch forms:', error);
      if (error.response?.status === 401) {
        setError('Session expired. Please log in again.');
        localStorage.removeItem('clientToken');
        window.dispatchEvent(new Event('clientAuthChange'));
        navigate('/client/login');
      } else {
        setError('Failed to load forms.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">Your Forms</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      {isLoading && <div className="alert alert-info">Loading...</div>}
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">Forms ({forms.length})</h4>
            </div>
            <div className="card-body">
              {forms.length === 0 && !isLoading && !error ? (
                <p className="text-muted text-center">No forms assigned yet.</p>
              ) : (
                <ul className="list-group list-group-flush">
                  {forms.map((form) => (
                    <li
                      key={form.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        {form.name || `Form ${form.id}`}
                        <small className="d-block text-muted">
                          Status: {form.status || 'Not set'}
                        </small>
                        <small className="d-block text-muted">
                          Last Updated: {new Date(form.lastUpdated).toLocaleDateString()}
                        </small>
                      </div>
                      <Link
                        to={`/form/${form.id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        Fill Out
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientForms;